import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReleaseDefinitionChangesResult } from '../mario/models/release-definition-changes-results';
import { ValidationResult } from '../models/validation-result';
@Injectable({
  providedIn: 'root',
})
export class RcjitService {
  private availableOrgs: Array<string> = [];
  constructor(private http: HttpClient) {}

  getAvailableOrgs(): Observable<Array<string>>{
    if(this.availableOrgs.length > 0) {
      return of(this.availableOrgs);
    }
    return this.http.get<Array<string>>(environment.rcjitapi.getOrgs).pipe(
      tap(orgs => this.availableOrgs = orgs)
    );
  }


  unlockRelease(org: string, project: string, releaseId: number): Observable<ValidationResult[]> {
    return this.http
      .put<ValidationResult[]>(
        environment.rcjitapi.grantUri.replace("{org}",org),
        {
          project: project,
          org: org,
          rcid: releaseId.toString(),
        },
        {
          observe: 'body',
        }
      );
  }

  lockRelease(org: string, project: string, releaseId: number): Observable<HttpResponse<Object>> {
    return this.http
      .put(
        environment.rcjitapi.revokeUri.replace("{org}",org),
        {
          project: project,
          org: org,
          rcid: releaseId.toString(),
        },
        {
          observe: 'response',
        }
      );
  }

  validateRelease(org: string, project: string, releaseId: number): Observable<ValidationResult[]> {
    return this.http
      .put<ValidationResult[]>(
        environment.rcjitapi.validateUri.replace("{org}",org),
        {
          project: project,
          org: org,
          rcid: releaseId.toString(),
        },
        {
          observe: 'body',
        }
      );
  }

  getReleaseChanges(org: string, project: string, releaseId: number): Observable<HttpResponse<ReleaseDefinitionChangesResult>> {
    return this.http.get<ReleaseDefinitionChangesResult>(environment.rcjitapi.getReleaseChangesUri
      .replace("{org}", org)
      .replace("{project}", project)
      .replace("{rcId}", releaseId.toString()
      ), {
        observe: 'response'
      }
    );
  }
}
